<template>
  <div class="mchnt-container">
    <el-form-item>
      <el-input v-model="code" :disabled="column.disabled" @change="getValue"></el-input>
      <el-button class="code-btn" type="primary" @click="getInfo" v-loading="loading">校验</el-button>
      <div v-if="mchntName">商户名称：{{mchntName}}</div>
    </el-form-item>
  </div>
</template>
<script>
export default {
  props: ['column'],
  data() {
    return {
      loading:false,
      mchntName:'',
      code: '',
    }
  },
  methods: {
    getValue(val){
      this.code = val
      this.$store.commit(this.$utils.storeKeys.SETFORMDATA, {
        key: this.column.prop,
        value: this.code
      });
    },
    //所有子组件必有此方法为当前数据赋值
    setValue(formModel) {
      formModel = formModel || this.$store.state[this.$utils.storeKeys.CURRENTFORM];
      this.code = formModel[this.column.prop];
    },
    getInfo() {
      if(this.code){
        this.loading = true
        this.$axios.fetchGet('/api/eros/se/seMerchant/get/mchnt?dbyPayMchnt='+this.code,{}).then(res => {
          if (res.code == 200 && res.data) {
            this.mchntName = res.data
          } else {
            this.$message({type: 'error', message: res.msg});
          }
        }).finally(()=>{
          this.loading = false
        })
      }else{
        this.$message.warning('请输入要检验的商户号')
      }
    },
    getFormData(){
      return this.code
    },
    clearData() {
      this.code = '';
      this.$store.commit(this.$utils.storeKeys.SETFORMDATA, {
        key: this.column.prop,
        value: ''
      });
    },
  }
}
</script>
<style scoped>
.mchnt-container .code-btn {
  min-width: 80px;
  max-width: 33.33%;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/mchntNo.vue